const blog = {
  state: {
    blog: {
      articles: []
    }
  },

  getters: {
    // this.$store.getters.getKidById(1)
    //getKidById: (state) => (id) => {
    //   return state.kids.find(kid => kid.id === id)
    //},

    getArticles: state => () => {
      return state.blog.articles;
    },
    getArticleBySlug: state => slug => {
      return state.blog.articles.find(article => {
        return article.slug === parseInt(slug);
      });
    }
  },

  mutations: {
    addArticles(state, articles) {
      state.blog.articles = [...articles];
    }
    //addKid (state, kid) {
    //   state.kids.push(kid)
    //},
    //
    //setKids (state, kids) {
    //   state.kids = kids
    //}
  }
};

export default blog;



// WEBPACK FOOTER //
// ./src/store/blog.js